import { createRouter, createWebHistory } from 'vue-router';

// 动态导入 views 目录下的所有 .vue 文件
const pages = require.context('../views', true, /\.vue$/);

// 生成路由配置
const routes = pages.keys().map((path) => {
  // 将文件路径转换为路由路径
  const routePath = path
    .replace('./', '') // 移除前缀
    .replace(/\.vue$/, '') // 移除 .vue 后缀
    .toLowerCase(); // 转换为小写

  // 将 index 或 home 转换为 /
  if (routePath === 'index' || routePath === 'home') {
    return {
      path: '/',
      component: pages(path).default, // 动态导入的组件
    };
  }

  // 处理嵌套路由
  const segments = routePath.split('/');
  if (segments.length > 1) {
    return {
      path: `/${routePath}`,
      component: pages(path).default,
    };
  }

  // 普通路由
  return {
    path: `/${routePath}`,
    component: pages(path).default,
  };
});

// 添加 404 路由
routes.push({
  path: '/:pathMatch(.*)*',
  component: () => import('../views/404.vue'),
});

// 创建路由实例
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;